<div class="editor" id="editor" element.ref="codeEditor"></div>
